module.exports = __webpack_public_path__ + "static/img/居家肿瘤癌痛患者三级医疗护理系统.418ffb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webSite/著作权/居家肿瘤癌痛患者三级医疗护理系统.png
// module id = 0DI4
// module chunks = 1